/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import {
    APPOINTMENT_STATUS,
    PDI_APPOINTMENT_STATUS,
    PDI_CATEGORY,
    PDI_PACKAGE_TYPES
} from "../../../constants/pre-delivery-inspection-constants";
import AppointmentSuccessIcon from "./images/appointment-success.svg";
import AppointmentFailedIcon from "./images/appointment-failed.svg";
import AppointmentWarningIcon from "./images/appointment-warning.svg";
import ReportInProgressIcon from "./images/report-in-progress.svg";
import PartialFulfilledIcon from "./images/partial-fulfilled.svg";
import { ORDER_STATUS } from "../my-order-summary-status/selector";
import { PDI_CAR_TYPE } from "../../../constants/pre-delivery-inspection-constants";
import { NUMBER } from "../../../constants/app-constants";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { ORDER_CATEGORY } from "../../../constants/my-orders-constants";
import { PDI_BOOKING_FLOW_USED_EVENTS } from "../../../constants/tracking-constants/pdi-revamp-tracking-constants";

export const PDI_INSPECT_KEYS = {
    [PDI_CAR_TYPE.USED_CAR]: "oldCarPdiProduct",
    [PDI_CAR_TYPE.NEW_CAR]: "newCarPdiProduct"
};

export const STATUS_TYPES = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    WARNING: "WARNING"
};

const PAGE_HEADINGS = {
    APPOINTMENT_DETAILS: "Appointment Details",
    ORDER_SUMMARY: "Order Summary"
};

const reportInProgressConfig = {
    label: "Report is in progress",
    desc: "Your report will be uploaded here and also sent to your WhatsApp",
    showDownload: false
};

const reportReadyConfig = {
    label: "Report ready for download",
    desc: "Your report is ready for download, we have sent it on WhatsApp too.",
    showDownload: true
};

const inspectionReportReadyConfig = {
    label: "Inspection report is ready",
    desc: "Your report is ready for download, we have sent it on WhatsApp too.",
    showDownload: true,
    isInspectionReport: true
};

const successAppointmentCase = {
    label: "Your appointment is confirmed!",
    desc: "Car expert details will be shared 1 hr before inspection.",
    icon: AppointmentSuccessIcon,
    type: STATUS_TYPES.SUCCESS,
    title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
    showAppointmentActions: true,
    showDocumentsInfo: true,
    event: "APPOINTMENT_CONFIRMED_SESSION",
    promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_NF
};

const reportInProgressCase = {
    label: "Your advanced report is in progress",
    desc: "Report will be ready within 1 hour.",
    icon: ReportInProgressIcon,
    type: STATUS_TYPES.WARNING,
    title: PAGE_HEADINGS.ORDER_SUMMARY,
    showAppointmentActions: false,
    showDocumentsInfo: false,
    reportCardConfig: reportInProgressConfig,
    event: "INSPECTION_DONE_SESSION",
    promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_NF
};

const progressStates = [
    ORDER_STATUS.FULFILLMENT_PENDING,
    ORDER_STATUS.FULFILLMENT_UNSUCCESSFULL
];

const PAYMENT_BADGE_CONFIG = {
    FULLY_REFUNDED: {
        variant: "success",
        label: "FULLY REFUNDED"
    },
    PARTIALLY_REFUNDED: {
        variant: "success",
        label: "PARTIALLY REFUNDED"
    }
};

export const APPOINTMENT_STATUS_MAPPING = {
    [PDI_APPOINTMENT_STATUS.APPOINTMENT_CONFIRMED]: successAppointmentCase,
    [PDI_APPOINTMENT_STATUS.BOTH_REPORT_IN_PROGRESS]: reportInProgressCase,
    [PDI_APPOINTMENT_STATUS.OLD_PDI_REPORT_IN_PROGRESS]: {
        ...reportInProgressCase,
        label: "Your report is in progress"
    },
    [PDI_APPOINTMENT_STATUS.PDI_REPORT_IN_PROGRESS]: {
        ...reportInProgressCase,
        label: "Your standard report is in progress"
    },
    [PDI_APPOINTMENT_STATUS.APPOINTMENT_CONFIRMED_CJ_ASSIGNED]: {
        label: "Your car expert is assigned!",
        desc: "Feel free to get in touch with them.",
        icon: AppointmentSuccessIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: true,
        showDocumentsInfo: true,
        event: "EXPERT_ASSIGNED_SESSION",
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_NF
    },
    [PDI_APPOINTMENT_STATUS.PARTIAL_FULFILLED]: {
        label: "Your inspection report is ready!",
        desc: "We’ll soon update the past service records.",
        icon: PartialFulfilledIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: {
            ...inspectionReportReadyConfig,
            notify: true
        },
        event: "PARTIAL_REPORT_READY_SESSION",
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_PF
    },
    [PDI_APPOINTMENT_STATUS.SH_FAIL_REFUND_INITIATED]: {
        label: "We couldn’t get past service records!",
        desc: "We’ll refund ₹{shRefundAmount} for the report shortly.",
        icon: AppointmentWarningIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: inspectionReportReadyConfig,
        event: "SH_FAIL_SESSION",
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_PR
    },
    [PDI_APPOINTMENT_STATUS.SH_FAIL_REFUND_COMPLETED]: {
        label: "We couldn’t get past service records!",
        desc: "We have credited ₹{shRefundAmount} to your bank.",
        icon: AppointmentWarningIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: inspectionReportReadyConfig,
        event: "SH_FAIL_SESSION",
        paymentBadge: PAYMENT_BADGE_CONFIG.PARTIALLY_REFUNDED,
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_PR
    },
    [PDI_APPOINTMENT_STATUS.INSPECTION_CANCELLED_REFUND_INITIATED]: {
        label: "Inspection cancelled",
        desc: "We have initiated a refund of ₹{fullRefundAmount}.",
        icon: AppointmentFailedIcon,
        type: STATUS_TYPES.WARNING,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        event: "INSPECTION_CANCELLED_SESSION",
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_FR
    },
    [PDI_APPOINTMENT_STATUS.INSPECTION_CANCELLED_REFUND_COMPLETED]: {
        label: "Inspection cancelled",
        desc: "We have credited ₹{fullRefundAmount} to your bank.",
        icon: AppointmentFailedIcon,
        type: STATUS_TYPES.WARNING,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        event: "INSPECTION_CANCELLED_SESSION",
        paymentBadge: PAYMENT_BADGE_CONFIG.FULLY_REFUNDED,
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_FR
    },
    [PDI_APPOINTMENT_STATUS.APPOINTMENT_MISSED]: {
        label: "Your appointment got missed!",
        desc: "Please re-schedule your inspection.",
        icon: AppointmentFailedIcon,
        type: STATUS_TYPES.ERROR,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: true,
        showDocumentsInfo: false
    },
    [PDI_APPOINTMENT_STATUS.BOTH_FULLFILLED]: {
        label: "Your advanced report is ready!",
        icon: AppointmentSuccessIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.ORDER_SUMMARY,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: reportReadyConfig,
        event: "REPORT_READY_SESSION",
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_F
    },
    [PDI_APPOINTMENT_STATUS.STANDARD_ORDER_FULFILLED]: {
        label: "Your standard report is ready!",
        icon: AppointmentSuccessIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.ORDER_SUMMARY,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: {
            ...reportReadyConfig,
            isInspectionReport: true
        },
        event: "REPORT_READY_SESSION"
    },
    [PDI_APPOINTMENT_STATUS.NEW_PDI_ORDER_FULFILLED]: {
        label: "Your report is ready!",
        icon: AppointmentSuccessIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.ORDER_SUMMARY,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: reportReadyConfig,
        event: "REPORT_READY_SESSION"
    },
    [PDI_APPOINTMENT_STATUS.OLD_PDI_ORDER_FULFILLED]: {       // Handles Backwards compatibility
        label: "Your report is ready!",
        icon: AppointmentSuccessIcon,
        type: STATUS_TYPES.SUCCESS,
        title: PAGE_HEADINGS.ORDER_SUMMARY,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        reportCardConfig: {
            ...reportReadyConfig,
            isInspectionReport: false
        },
        event: "REPORT_READY_SESSION"
    },
    [PDI_APPOINTMENT_STATUS.REPORT_FAIL_REFUND_INITIATED]: {
        label: "We couldn’t generate your report",
        desc: "Full refund for the report has been initiated",
        icon: AppointmentFailedIcon,
        type: STATUS_TYPES.ERROR,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_FR
    },
    [PDI_APPOINTMENT_STATUS.REPORT_FAIL_REFUND_COMPLETED]: {
        label: "We couldn’t generate your report",
        desc: "We have credited ₹{fullRefundAmount} to your bank.",
        icon: AppointmentFailedIcon,
        type: STATUS_TYPES.ERROR,
        title: PAGE_HEADINGS.APPOINTMENT_DETAILS,
        showAppointmentActions: false,
        showDocumentsInfo: false,
        paymentBadge: PAYMENT_BADGE_CONFIG.FULLY_REFUNDED,
        promiseEvent: PDI_BOOKING_FLOW_USED_EVENTS.PDI_PROMISE_POST_LOAD_FR
    }
};

export const getAppointmentStatus = ({
    orderDetails = {},
    appointmentStatus = "",
    isMissedAppointment = false,
    cjDetail = null,
    reportType
}) => {
    const orderStatus = orderDetails?.status || "";

    const isAppointmentMissed = isMissedAppointment &&
      ![APPOINTMENT_STATUS.INSPECTION_STARTED, APPOINTMENT_STATUS.INSPECTED].includes(appointmentStatus);

    const isRefundFlow = [ORDER_STATUS.REFUND_PENDING, ORDER_STATUS.REFUNDED, ORDER_STATUS.REFUND_FAILED].includes(orderStatus);

    if (isRefundFlow) {
        const isInspected = appointmentStatus === APPOINTMENT_STATUS.INSPECTED;

        if (orderStatus === ORDER_STATUS.REFUNDED) {
            return APPOINTMENT_STATUS_MAPPING[
                isInspected
                    ? PDI_APPOINTMENT_STATUS.REPORT_FAIL_REFUND_COMPLETED
                    : PDI_APPOINTMENT_STATUS.INSPECTION_CANCELLED_REFUND_COMPLETED
            ];
        }

        return APPOINTMENT_STATUS_MAPPING[
            isInspected
                ? PDI_APPOINTMENT_STATUS.REPORT_FAIL_REFUND_INITIATED
                : PDI_APPOINTMENT_STATUS.INSPECTION_CANCELLED_REFUND_INITIATED
        ];
    }

    if (isAppointmentMissed) {
        return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.APPOINTMENT_MISSED];
    }

    if ([APPOINTMENT_STATUS.BOOKED, APPOINTMENT_STATUS.CONFIRMED, APPOINTMENT_STATUS.PURCHASED].includes(appointmentStatus)) {
        return APPOINTMENT_STATUS_MAPPING[
            cjDetail
                ? PDI_APPOINTMENT_STATUS.APPOINTMENT_CONFIRMED_CJ_ASSIGNED
                : PDI_APPOINTMENT_STATUS.APPOINTMENT_CONFIRMED
        ];
    }

    const isProgressOrder = [
        ORDER_STATUS.FULFILLMENT_PENDING,
        ORDER_STATUS.PARTIALLY_FULFILLED,
        ORDER_STATUS.FULFILLMENT_UNSUCCESSFULL
    ].includes(orderStatus);

    if (isProgressOrder) {
        if (!reportType) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.OLD_PDI_REPORT_IN_PROGRESS];
        }
        if (reportType === PDI_PACKAGE_TYPES.STANDARD) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.PDI_REPORT_IN_PROGRESS];
        }

        const subItems = orderDetails?.orderSubItems || [];

        const pdiStatus = subItems.find(item =>
            [PDI_CATEGORY.USED_CAR_PDI, PDI_CATEGORY.INSPECTION_REPORT].includes(item?.category)
        )?.status;

        const shStatus = subItems.find(item =>
          item?.category === PDI_CATEGORY.SERVICE_HISTORY
        )?.status;

        const bothInProgress = progressStates.includes(pdiStatus) && progressStates.includes(shStatus);
        const partialFulfilled = pdiStatus === ORDER_STATUS.FULFILLED && progressStates.includes(shStatus);

        if (pdiStatus === ORDER_STATUS.FULFILLED) {
            if (shStatus === ORDER_STATUS.REFUND_PENDING) {
                return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.SH_FAIL_REFUND_INITIATED];
            }
            if (shStatus === ORDER_STATUS.REFUNDED) {
                return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.SH_FAIL_REFUND_COMPLETED];
            }
        }

        if (bothInProgress) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.BOTH_REPORT_IN_PROGRESS];
        }

        if (partialFulfilled) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.PARTIAL_FULFILLED];
        }

        return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.BOTH_REPORT_IN_PROGRESS];
    }

    if (orderStatus === ORDER_STATUS.FULFILLED) {
        if (reportType === PDI_PACKAGE_TYPES.STANDARD) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.STANDARD_ORDER_FULFILLED];
        } else if (reportType === PDI_PACKAGE_TYPES.ADVANCED) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.BOTH_FULLFILLED];
        } else if (reportType === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION) {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.NEW_PDI_ORDER_FULFILLED];
        } else {
            return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.NEW_PDI_ORDER_FULFILLED];
        }
    }

    return APPOINTMENT_STATUS_MAPPING[PDI_APPOINTMENT_STATUS.APPOINTMENT_CONFIRMED];
};

export const getParsedIntentData = (pdiData, cmsData) => {
    let heroBannerSection = {};
    const pageSections = cmsData?.pageSections || [];

    for (let i = 0; i < pageSections.length; i++) {
        const pageSection = pageSections?.[i].pageSection || {};
        if (pageSection?.name === "PDI_HERO_BANNER" || pageSection.name.startsWith("PDI_HERO_BANNER")) {
            heroBannerSection = pageSection;
            break;
        }
    }
    const bannerData = heroBannerSection?.subSections?.[0]?.sectionData || [];

    return (bannerData || []).map((banner) => {
        let widgetName = "";

        if (banner?.title?.value === "Brand new car") {
            widgetName = "PDI_New_Car_V2";
        } else if (banner?.title?.value === "Used car") {
            widgetName = "PDI_Used_Car_V2";
        }

        const amount = pdiData?.[PDI_INSPECT_KEYS?.[widgetName]]?.amount;

        return {
            ...banner,
            widgetName,
            isEnable: true,
            ctaPrice: amount
        };
    });
};

export const getRefundAmount = orderDetails => {
    let shRefundAmount = 0;

    const { product = {}, orderSubItems = [] } = orderDetails || {};

    const { netAmount = NUMBER.ZERO } = product || {};

    if (orderSubItems && orderSubItems.length > NUMBER.ONE) {
        shRefundAmount = orderSubItems.find(
            item => item?.category === PDI_CATEGORY.SERVICE_HISTORY
        )?.netAmount;
    }

    return {
        fullRefundAmount: priceFormatter(netAmount),
        shRefundAmount: priceFormatter(shRefundAmount)
    };
};

export const replaceTextLiterals = (text = "", replacements = {}) => {
    if (!text || typeof text !== "string") return text;

    return text.replace(/\{(\w+)\}/g, (_, key) => {
        return key in replacements ? replacements[key] : `{${key}}`;
    });
};
